<template>
  <footer :class='$style.container'>
    <div :class='$style.main'>
      <lazy-image :class='$style.logo' :src='require("../assets/logo.png")' />
      <div :class='$style.flex'>
        <div :class='$style.flexItem'>
          <p>官方微信公众号</p>
          <lazy-image :class='$style.qrcode' :src='require("../assets/wx.jpg")' />
        </div>
        <div :class='$style.flexItem'>
          <p>官方微信小程序商城</p>
          <lazy-image :class='$style.qrcode' :src='require("../assets/mp.jpg")' />
        </div>
      </div>
      <div :class='[$style.flex,$style.icons]'>
        <div :class='[$style.flex,$style.flexItem]'>
          <div :class='$style.flexItem'>
            <lazy-image :class='$style.iconDiam' :src='require("../assets/icon-diam.png")' />
            <p>品质无忧</p>
          </div>
          <div :class='$style.flexItem'>
            <lazy-image :class='$style.iconGift' :src='require("../assets/icon-gift.png")' />
            <p>高端礼盒</p>
          </div>
        </div>
        <div :class='[$style.flex,$style.flexItem]'>
          <div :class='$style.flexItem'>
            <lazy-image :class='$style.iconExpress' :src='require("../assets/icon-express.png")' />
            <p>顺丰空运</p>
          </div>
          <div :class='$style.flexItem'>
            <lazy-image :class='$style.iconLike' :src='require("../assets/icon-like.png")' />
            <p>死蟹包赔</p>
          </div>
        </div>
      </div>
    </div>
    <div :class='$style.copyright'>
      © 2019 冠鳌。
      <a href='http://www.beian.miit.gov.cn/'>沪ICP备19026916号-4</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "LayoutFooter"
};
</script>

<style lang='scss' module>
@import "../tool";
@media screen and(max-width:750px) {
  .icons {
    flex-direction: column;
  }
  .flex.flexItem {
    width: 100% !important;
  }
  .flex.flexItem ~ .flexItem {
    margin-top: rem(20);
  }
}
.container {
  color: #d8c39f;
}
.main {
  padding-top: 32px;
  padding-bottom: 40px;
  text-align: center;
  font-size: 14px;
  background: #371f1f;
}
.logo {
  width: 176px;
  height: 81px;
}
.flex {
  display: flex;
  align-items: flex-end;
}
.flexItem {
  flex: 1;
}
.qrcode {
  margin-top: 8px;
  width: 126px;
  height: 126px;
}
.iconDiam {
  width: 64px;
  height: 65px;
}
.iconGift {
  width: 58px;
  height: 72px;
}
.iconExpress {
  width: 86px;
  height: 46px;
}
.iconLike {
  width: 58px;
  height: 65px;
}
.icons {
  margin-top: 50px;
}
.copyright {
  text-align: center;
  line-height: 62px;
  font-size: 14px;
  color: #333;
}
</style>